import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_USER_EQC_APPROVAL_LOGS = gql`
  query getUserEqcApprovalLogs($filter: EqcApprovalLogInput!) {
    getUserEqcApprovalLogs(filter: $filter) {
      total
      data {
        id
        updatedAt
        levelName
        levelNumber
        tenant {
          id
          organizationName
        }
        approvalDetails
        eqc {
          id
          eqcName
          projectEqcTypeName
          project {
            timeZone
            id
            name
          }
        }
        eqcStageHistory {
          id
          name
          status
          eqcStageId
          approvalType
          levelName
          isRfiStage
          levelNumber
          inspectorReminderDate
        }
        approvalSender {
          id
          name
          email
        }
        internalApprover {
          id
          project {
            id
            name
          }
          user {
            id
            name
          }
        }
        eqcStage {
          id
          name
          status
          eqcStageApprovals {
            id
            internalApproverId
            levelName
            levelNumber
            externalUserApproverId
            internalApproverName
            externalUserApproverName
          }
        }
        approvalUrl
      }
    }
  }
`;

export const GET_USER_EQC_APPROVAL_LOGS_COUNT = gql`
  query getUserEqcApprovalLogs($filter: EqcApprovalLogInput!) {
    getUserEqcApprovalLogs(filter: $filter) {
      total
    }
  }
`;

export const ACTIVITY_LOGS = gql`
  query eqcActivityLogList($filter: EqcActivityLogFilter) {
    eqcActivityLogList(filter: $filter) {
      total
      data {
        id
        projectId
        projectName
        eqcType
        eqcStageName
        eqcId
        stageId
        eqcStagesId
        eqcName
        eqcStatus
        eqcStageStatus
        creatorName
        externalUserApproverName
        internalApproverName
        timeZone
        eqcStageApprovals {
          id
          internalApproverId
          externalUserApproverId
          internalApproverName
          externalUserApproverName
        }
        dueDate
        createdAt
      }
    }
  }
`;

export const EQC_LIST = gql`
  query eqcTypeDropdownList($filter: EqcTypeFilter) {
    eqcTypeDropdownList(filter: $filter) {
      total
      data {
        id
        name
      }
    }
  }
`;

export const USER_INSTRUCTION_TODO_LIST = gql`
  query userInstructionTodoList($filter: InstructionFilter!) {
    userInstructionTodoList(filter: $filter) {
      total
      instructionActionableCount
      data {
        id
        name
        tags
        type
        status
        reminderDate
        createdAt
        isOverdue
        respondedOn
        updatedAt
        project {
          id
          name
          timeZone
        }
        responderUser {
          id
          name
        }
        modifier {
          id
          name
        }
        rejector {
          id
          name
        }
        tenant {
          id
          organizationName
        }
      }
    }
  }
`;
